import {BaseApi} from "@/core/api/base.api";
import {Room} from "@/core/api/room.api";
import {roomDocService} from "@/core/service/room.doc.service";
import _ from 'lodash'
import {lmsDocService} from "@/core/service/lms.doc.service";
import GrmObservable from "@/lib/gooroomee/utils/GrmObservable";
import { RoomInfo } from '@/core/api/room.info.api'

class RoomDocApi extends BaseApi {
    #pageCacheData = {};
    #roomDocService;
    #grmObservable = new GrmObservable();
    #roomDocDownloadUrlJob = [];

    constructor() {
        super();
        Room.Doc = this;

        Room.ready(async e => {
            if(!RoomInfo.useModule('docShare')){
                return;
            }

            this._eventListen(this.#Events);

            if(lmsDocService.isLmsRoom(Room.getRoomData().room)){
                this.#roomDocService = lmsDocService;
            }else{
                this.#roomDocService = roomDocService;
            }

            // let {data} = await this.#roomDocService.getRoomDocInfo()
            let {data} = await this.#roomDocService.getRoomDocInfoList()
            if(!data){
                console.error('get roomDoc fail :', data);
                return;
            }

            let roomGroups = data.reduce((map, roomDoc) => {
                roomDoc.roomDocFiles && roomDoc.roomDocFiles.forEach(roomDocFile => this.parseRoomDocFile(roomDocFile));

                map[roomDoc.roomGroupId] = roomDoc;
                Room.Group.addData(roomDoc.roomGroupId, {roomDoc});
                return map;
            }, {});

            let roomDoc = roomGroups['default'];
            roomDoc.roomGroups = roomGroups;

            Room.addRoomData({roomDoc});
        });
    }

    parseRoomDocFile(roomDocFile) {
        if(!roomDocFile.docData){
            return;
        }
        try{
            roomDocFile.docData = JSON.parse(roomDocFile.docData);
        }catch(e){
            console.warn(e);
        }

        roomDocFile.isWhiteboard = this.isWhiteBoardFile(roomDocFile);
        roomDocFile.isDir = this.isDirFile(roomDocFile);

        if(roomDocFile.isWhiteboard){
            this.parseDrawData(roomDocFile.drawList);
            // if(!roomDocFile.drawList){
            //     roomDocFile.drawList = [];
            // }
        }

        roomDocFile.pages && roomDocFile.pages.forEach(page => {
            if(!page.drawList) return;

            this.parseDrawData(page.drawList);
            // if(!page.drawList){
            //     page.drawList = [];
            // }
        });
    }

    parseDrawData(draw) {
        if(!draw) return;
        if(Array.isArray(draw)){
            draw.forEach(d => this.parseDrawData(d));
            return draw;
        }

        if(draw.data && typeof(draw.data) === 'string'){
            draw.data = JSON.parse(draw.data);

            if(!draw.drawType){
                draw.drawType = 'drawing';
            }
        }

        if(Array.isArray(draw.data)){
            draw.data = {
                point: {
                    x: draw.data[0],
                    y: draw.data[1],
                }
            };
        }
        return draw;
    }

    async addRoomDoc(roomDoc) {
        if(!roomDoc) return null;
        let prevRoomDoc = await this.getRoomDoc(roomDoc.roomGroupId);
        if(prevRoomDoc === null) return null;
        if(prevRoomDoc === undefined) {
            let roomGroup = Room.Group.getRoomGroup(roomDoc.roomGroupId);
            roomGroup.roomDoc = {};
            prevRoomDoc = await this.getRoomDoc(roomDoc.roomGroupId);
        }
        Object.keys(roomDoc)
            .filter((key) => key !== 'roomDocFiles')
            .forEach((key) => prevRoomDoc[key] = roomDoc[key]);

        if(!prevRoomDoc.roomDocFiles) prevRoomDoc.roomDocFiles = [];
        roomDoc.roomDocFiles && roomDoc.roomDocFiles.forEach(async (roomDocFile) => await this.addRoomDocFile(roomDocFile))
    }

    async addRoomDocFile(roomDocFile) {
        let prevRoomDocFile = await this.getRoomDocFile({roomDocFile});
        if(prevRoomDocFile) {
            _.merge(prevRoomDocFile, roomDocFile);
        } else {
            let roomDocFiles = await this.getRoomDocFiles(roomDocFile);
            roomDocFiles.push(roomDocFile);
        }
    }

    #Events = {
        room_doc_setDocId: async function (e){
            let {roomDoc} = e.data;
            let roomGroup = await this.getRoomDoc(roomDoc.roomGroupId);
            if(!roomGroup){
                console.warn('roomGroup is null :', roomDoc);
            } else {
                roomGroup.docId = roomDoc.docId
                Room.emit(e.type, {roomGroupId: roomDoc.roomGroupId, docId: roomDoc.docId})
            }
        },
        room_doc_add: async function(e){
            let {roomDocFile} = e.data;
            let roomGroup = await this.getRoomDoc(roomDocFile.roomGroupId);
            if(!roomGroup){
                console.warn('roomGroup is null :', roomDocFile);
            }

            let prev = await this.getRoomDocFile(roomDocFile);
            if(prev){
                _.merge(prev, roomDocFile);
                roomDocFile = prev;
            }else{
                roomGroup.roomDocFiles.push(roomDocFile);
            }

            this.parseRoomDocFile(roomDocFile);
            Room.emit(e.type, {userId: e.userId, roomDocFile: _.cloneDeep(roomDocFile)});
        },
        room_doc_remove: async function(e){
            let {roomGroupId, docId} = e.data;
            let roomDoc = await this.getRoomDoc(roomGroupId);
            if(!roomDoc){
                console.warn('roomDoc is null :', roomGroupId);
            }

            let idx = roomDoc.roomDocFiles.findIndex(roomDocFile => roomDocFile.docId == docId);
            if(idx < 0){
                return;
            }
            roomDoc.roomDocFiles.splice(idx, 1);

            Room.emit(e.type, {userId: e.userId, roomGroupId, docId});
        },
        room_doc_startConvert: async function(e){
            let {roomDocFile} = e.data;
            let currRoomDocFile = await this.getRoomDocFile(roomDocFile);
            if(currRoomDocFile){
                let pages = currRoomDocFile.pages;
                _.assign(currRoomDocFile, roomDocFile);
                currRoomDocFile.pages = pages;
                roomDocFile = currRoomDocFile;
            }
            Room.emit(e.type, {roomDocFile: _.cloneDeep(roomDocFile)});
        },
        room_doc_addConvertPage: async function(e){
            let {roomDocFile, docFilePage, end} = e.data;

            let currRoomDocFile = await this.getRoomDocFile(roomDocFile);
            if(currRoomDocFile){
                let pages = currRoomDocFile.pages;
                _.assign(currRoomDocFile, roomDocFile);
                currRoomDocFile.pages = pages;
                roomDocFile = currRoomDocFile;
            }
            if(!roomDocFile.pages){
                roomDocFile.pages = [];
            }
            docFilePage.drawList = docFilePage.drawList || [];
            roomDocFile.pages.push(docFilePage);
            roomDocFile.pages.sort((a,b) => a.docPageSeq - b.docPageSeq);

            try{
                if(roomDocFile.docFile && roomDocFile.pages){
                    if(roomDocFile.docFile.docPageCnt > 0){
                        roomDocFile.docFile.docPageCnt = Math.max(roomDocFile.docFile.docPageCnt, roomDocFile.pages.length);
                    }
                }
            }catch(e){
                console.error(e);
            }

            Room.emit(e.type, {
                roomDocFile: _.cloneDeep(roomDocFile),
                docFilePage: _.cloneDeep(docFilePage),
                end: !!end
            });
        },
        room_doc_convertComplete: async function(e){
            let {roomDocFile} = e.data;
            let currRoomDocFile = await this.getRoomDocFile(roomDocFile);
            currRoomDocFile.docFile.docConvPageCnt = currRoomDocFile.docFile.docPageCnt;
            if(currRoomDocFile.docFile.docState === 9){
                return;
            }

            let docFilePage = currRoomDocFile.pages && currRoomDocFile.pages[currRoomDocFile.pages.length - 1];

            Room.emit('room_doc_addConvertPage', {
                roomDocFile: _.cloneDeep(roomDocFile),
                docFilePage: _.cloneDeep(docFilePage),
                end: true
            });
        },
        room_doc_convertError: async function(e) {
            let {roomDocFile} = e.data;
            if (Room.User.isMe(e.userId)) {
                try {
                    await this.removeRoomDoc(roomDocFile);
                } catch (e) {
                    console.error('fail remove roomDocFile: roomGroupId[%s], docId[%s], msg[%s]',
                      roomDocFile.roomGroupId, roomDocFile.docId, e
                    );
                }
            }
            Room.emit(e);
        },
        room_doc_draw: async function(e){
            let draw = e.data.draw;
            let {roomGroupId, docId, docPageId} = draw;
            let userId = e.userId;

            this.parseDrawData(draw.data);

            let isPass = !draw.data.toolkit || draw.data.toolkit === 'LaserPointer';

            if(!isPass){
                let roomDocFile = await this.getRoomDocFile({docId, roomGroupId});
                let page;
                if(this.isWhiteBoardFile(roomDocFile)){
                    page = roomDocFile;
                }else if(roomDocFile.docFile.docPageCnt == 0) {
                    page = roomDocFile;
                }else{
                    page = await this.getRoomDocFilePage({docId, docPageId, roomGroupId});
                }
                if(!page){
                    console.warn('page is null :', docId, docPageId);
                    return;
                }
                if(!page.drawList){
                    page.drawList = [];
                }

                switch(draw.data.drawType){
                    case 'drawtext':
                    case 'drawend':
                        page.drawList.push( draw.data );
                        break;
                    case 'clear':
                        if(page.drawList){
                            page.drawList = [];
                        }
                        break;
                }
            }

            if(Room.User.isMe(userId)){
                return;
            }

            Room.emit(e.type, {userId, draw});
        },
        room_doc_changeRoomDocPage: async function(e){
            let {roomGroupId, docId, docPageId, docPageSeq, drawList} = e.data;

            let roomDoc = await this.getRoomDoc(roomGroupId);
            Object.assign(roomDoc, {...{docId, docPageId}});

            let roomDocFile = await this.getRoomDocFile({docId, roomGroupId});
            roomDocFile.currDocPageId = docPageId;
            roomDocFile.currDocPageSeq = docPageSeq;

            // let existDrawList = false;
            if(drawList){
                let file = roomDocFile;
                if(docPageId){
                    file = await this.getRoomDocFilePage({roomGroupId, docId, docPageId});
                }
                // existDrawList = !!file.drawList;
                file.drawList = file.drawList || this.parseDrawData(drawList);
            }

            if(e.data.downloadUrl){
                this.getRoomDocUrl({
                    roomGroupId, docId, docPageId,
                    downloadUrl: e.data.downloadUrl
                }).catch(e => {
                    console.error(e);
                });
            }

            Room.emit(e.type, {
                userId: e.userId, roomGroupId, docId, docPageId, docPageSeq,
                // drawList: existDrawList ? null : _.cloneDeep(drawList)
            });

            // // cache
            // clearTimeout(this._cache_timer);
            // this._cache_timer = setTimeout(() => {
            //     this.cacheRoomDocFiePages({docId, docPageId, roomGroupId});
            // }, 100 + (Math.random() * 2000));
        },
        room_doc_changeSharing: async function(e) {
            let {roomGroupId} = e.data;
            let roomDoc = await this.getRoomDoc(roomGroupId);
            if(!roomDoc){
                console.warn('roomDoc is null :', roomGroupId);
            }

            Room.emit(e.type, {roomGroupId})
        },
        room_doc_setDocList: function(e) {
            const {roomDocList} = e.data
            roomDocList && roomDocList.forEach(async (roomDoc) => await RoomDoc.addRoomDoc(roomDoc))

            Room.emit(e.type, {
                roomDocList: _.cloneDeep(roomDocList)
            })
        }
    };

    sendDraw(draw) {
        // lagacy 호환
        if(draw.docPageSeq !== undefined || draw.drawData){
            let _draw = {
                roomGroupId: draw.roomGroupId,
                docId: draw.docId,
                docPageId: draw.docPageSeq,
                data: {
                    v: draw.v,
                    drawType: draw.drawType,
                    toolkit: draw.toolkit,
                }
            };

            if(draw.drawData){
                _draw.data.data = draw.drawData;
            }
            draw = _draw;
        }else{
            //
        }

        // performance
        let chk = draw.data.drawType !== 'clear' && (!draw.data.toolkit || draw.data.toolkit === 'LaserPointer');
        if(chk){
            if(Room.getRoomData().roomUserList.length <= 1){
                return;
            }

            if(draw.data.drawType == 'drawing'){
                delete draw.data.drawType;
                draw.data.data = [draw.data.data.point.x, draw.data.data.point.y];
            }
        }else{
            // var roomDocPage = this.getRoomDocPage(draw.data.docId, draw.data.docPageSeq);
            // if(roomDocPage){
            //     if(!roomDocPage.drawList){
            //         roomDocPage.drawList = [];
            //     }
            //     roomDocPage.drawList.push( draw.data );
            // }
        }

        if(draw.data && draw.data.data){
            draw.data.data = JSON.stringify(draw.data.data);
        }

        if(!chk){
            this.#roomDocService.sendDraw(draw);
        }else{
            Room.getClient().send('/room/doc/sendDraw', draw)
        }
    }

    async getRoomDoc(roomGroupId='default') {
        let roomGroup = Room.Group.getRoomGroup(roomGroupId);
        if(!roomGroup){
            return null;
        }
        return roomGroup.roomDoc;
    }

    async getRoomDocFiles({roomGroupId='default'}) {
        let roomGroupData = Room.Group.getRoomGroup(roomGroupId);
        let list = roomGroupData.roomDoc.roomDocFiles;
        return list;
    }

    async getRoomDocFile({docId, roomGroupId='default'}) {
        let roomGroupData = Room.Group.getRoomGroup(roomGroupId);
        let list = roomGroupData.roomDoc.roomDocFiles;
        let roomDocFile = list.find(file => file.docId === docId);
        return roomDocFile;
    }

    async getRoomDocDrawList({docId, docPageId, roomGroupId='default'}) {
        let getDrawList = async ({docId, docPageId, roomGroupId}) => {
            return new Promise((resolve, reject) => {
                this.#grmObservable.getOrCreate(`drawList_${docId+'@'+docPageId+'@'+roomGroupId}`, async obs => {
                    let drawList = (await this.#roomDocService.getRoomDocDrawList({docId, docPageId, roomGroupId})).data;
                    obs.complete(drawList);
                }).subscribe(
                    resolve,
                    reject,
                    () => {}
                );
            });
        }



        let roomDocFile = await this.getRoomDocFile({docId, roomGroupId});
        if(!roomDocFile){
            console.warn('roomDocFile is null :', docId, docPageId, roomGroupId);
            return null;
        }

        if(!docPageId){
            if(!roomDocFile.drawList){
                let drawList = (await getDrawList({docId, docPageId, roomGroupId}));
                roomDocFile.drawList = this.parseDrawData(drawList) || [];
            }
            return roomDocFile.drawList;
        }

        let page = await this.getRoomDocFilePage({docId, docPageId, roomGroupId});
        if(!page){
            return null;
        }

        if(!page.drawList){
            let drawList = (await getDrawList({docId, docPageId, roomGroupId}));
            page.drawList = this.parseDrawData(drawList) || [];
        }

        return page.drawList;
    }

    isWhiteBoardFile(docFile) {
        // if(typeof(docFile) === 'string'){
        //     docFile = await this.getRoomDocFile(docFile);
        // }
        if(!docFile){
            return false;
        }
        return docFile.docType === 'wb';
    }
    isDirFile(docFile) {
        // if(typeof(docFile) === 'string'){
        //     docFile = await this.getRoomDocFile(docFile);
        // }
        if(!docFile){
            return false;
        }
        return docFile.docType === 'dir';
    }

    async getRoomDocFilePages({docId, roomGroupId}) {
        let {data} = await this.#roomDocService.getRoomDocFilePages({docId});
        return data;
    }

    async getRoomDocFilePage({docId, docPageId, roomGroupId}) {
        let roomDocFile = await this.getRoomDocFile({docId, roomGroupId});
        if(!roomDocFile){
            return null;
        }

        if(!this.isWhiteBoardFile(roomDocFile) && !this.isDirFile(roomDocFile)
            && !roomDocFile.pages
            && (roomDocFile.docFile && roomDocFile.docFile.docPageCnt > 0)
        ){
            roomDocFile.pages = await this.getRoomDocFilePages({docId, roomGroupId});
            if(roomDocFile.pages){
                this.parseRoomDocFile(roomDocFile);
                let rdf = _.cloneDeep(roomDocFile);
                roomDocFile.pages.forEach(page => {
                    Room.emit('room_doc_addPage', {
                        roomDocFile: rdf,
                        docFilePage: _.cloneDeep(page)
                    });
                });
            }
        }

        let docFilePage = roomDocFile.pages && roomDocFile.pages.find(page => page.docPageId === docPageId);
        return docFilePage;
    }

    async changeRoomDocFilePage({docId, docPageId, roomGroupId}) {
        await this.getRoomDocFilePage({docId, docPageId, roomGroupId});
        this.#roomDocService.changeRoomDocFilePage({docId, docPageId, roomGroupId});

        // // cache
        // await this.cacheRoomDocFiePages({docId, docPageId, roomGroupId});
    }

    // cache 로직 제거
    // async cacheRoomDocFiePages({docId, docPageId, roomGroupId}) {
    //     let roomDocFile = await this.getRoomDocFile({docId, roomGroupId});
    //
    //     if(!docPageId){
    //         docPageId = roomDocFile.currDocPageId;
    //     }
    //
    //     // prev, next page
    //     await (async () => {
    //         let pages = roomDocFile.pages;
    //         if(!pages || pages.length == 0) return;
    //
    //         let idx = pages.findIndex(page => page.docPageId == docPageId);
    //         if(idx < 0) return;
    //
    //         [
    //             idx-1 > -1 ? idx-1 : pages.length-1,
    //             idx+1 < pages.length ? idx+1 : 0
    //         ].forEach(i => {
    //             this.getRoomDocUrl(pages[i]).then(url => {
    //                 let img = new Image();
    //                 img.onerror = e => {
    //                     console.error('page url error [roomDocFilePage] :', pages[i].docId, pages[i].docPageId, url, e);
    //                 };
    //                 img.src = url;
    //             });
    //         });
    //     })();
    //
    //     // next roomDocFile
    //     await (async () => {
    //         let roomDocFiles = await this.getRoomDocFiles({roomGroupId});
    //         if(!roomDocFiles){
    //             return;
    //         }
    //         let idx = roomDocFiles.findIndex(f => f.docId === roomDocFile.docId);
    //         if(idx < 0){
    //             return;
    //         }
    //         let next = roomDocFiles[idx+1];
    //         if(!next){
    //             return;
    //         }
    //         if(this.isWhiteBoardFile(next) || this.isDirFile(next) || (next.docFile && next.docFile.docPageCnt > 0)){
    //             return;
    //         }
    //         this.getRoomDocUrl(next).then(url => {
    //             let img = new Image();
    //             img.onerror = e => {
    //                 console.error('page url error [roomDocFile] :', next.docId, url, e);
    //             };
    //             img.src = url;
    //         });
    //     })();
    // }

    // async requestPresignedUrlForRoomDocFile() {
    //     return (await this.#roomDocService.requestPresignedUrlForRoomDocFile()).data;
    // }

    // async completedPresignedUrlRoomDocFile(data) {
    //     return this.#roomDocService.completedPresignedUrlRoomDocFile(data);
    // }

    async uploadToPresignedUrl ({url, file, onUploadProgress}) {
        return this.#roomDocService.uploadToPresignedUrl({url, file, onUploadProgress});
    }

    // async createUploadPresignedUrl(data) {
    //     return (await this.#roomDocService.createUploadPresignedUrl(data)).data;
    // }

    async uploadRoomDoc_old({roomGroupId, filename, file, setRoomDoc, onUploadProgress}) {
        return this.#roomDocService.uploadRoomDoc({roomGroupId, filename, file, setRoomDoc, onUploadProgress});
    }

    async uploadRoomDoc({roomGroupId, filename, file, setRoomDoc, onUploadProgress}) {
        filename = filename || file.name;
        const fileExt = filename.substring( filename.lastIndexOf('.')+1 ).toLowerCase();
        const testImg = new RegExp('(png|jpg|jpeg|bmp|gif)$', 'i');

        let thumbnail;
        if(testImg.test(fileExt)){
            thumbnail = await this.createImage({imageType: 'jpg', filename, file, width: 192, height: 108});
            thumbnail.filename = filename + '.jpg';
        }

        let res;
        try {
            res = (await this.#roomDocService.createUploadPresignedUrl({
                filename,
                filesize: file.size,
                contentType: file.type,
                roomGroupId,
                thumbnail: !!thumbnail
            })).data
            if(!res.url) {
                throw new Error()
            }
        } catch (e) {
            console.error('Colud not get doc file presigend Url', e);
            throw e;
        }

        const {token, url, thumbnailUrl} = res;
        try {
            await this.uploadToPresignedUrl({url, file, onUploadProgress})
            if(thumbnail && thumbnailUrl){
                await this.uploadToPresignedUrl({url: thumbnailUrl, file: thumbnail})
            }
            await this.#roomDocService.addFromPresignedUrl({token})
        }catch (e) {
            console.error('Could not upload doc file to Presigned-Url', e)
            throw e;
        }
    }

    async uploadRoomDocFileGroupList({roomGroupIds, filename, file, setRoomDoc, onUploadProgress}) {
        return this.#roomDocService.uploadRoomDocFileGroupList({roomGroupIds, filename, file, setRoomDoc, onUploadProgress});
    }

    async getRoomDocUrl({roomGroupId, docId, docPageId, thumbnail, downloadUrl}) {
        let roomDocFile = await this.getRoomDocFile({docId, roomGroupId});
        if(this.isWhiteBoardFile(roomDocFile)){
            thumbnail = false;
        }

        if(!docPageId){
            if(roomDocFile.docFile?.pages){
                docPageId = roomDocFile.docFile.pages[0].docPageId;
            }
        }

        const key = `${docId}@${docPageId}@${thumbnail}`;
        let cache = this.#pageCacheData[key];

        if(cache && typeof(cache) === 'string'){
            if(!cache.startsWith('blob:')){
                cache = this.#pageCacheData[key] = await (async () => {
                    let {url} = await this.#roomDocService.createObjectURL({url: cache});
                    return url;
                })();
            }
            return cache;
        }

        return new Promise((resolve, reject) => {
            this.#grmObservable.getOrCreate(`roomDocUrl_${docId+'@'+docPageId+'@'+roomGroupId+'@'+thumbnail}`, async obs => {
                let url;
                if(downloadUrl){
                    let res = await this.#roomDocService.createObjectURL({url: downloadUrl});
                    url = res.url;
                }else if(this.isWhiteBoardFile(roomDocFile)){
                    let {width, height, color} = roomDocFile.docData;
                    let canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    let ctx = canvas.getContext('2d');
                    ctx.fillStyle = color || '#fff';
                    ctx.fillRect(0, 0, width, height);
                    // url = canvas.toDataURL();
                    url = await new Promise(r => {
                        canvas.toBlob((blob) => {
                            r(URL.createObjectURL(blob));
                        });
                    });
                }else{
                    this.#roomDocDownloadUrlJob.push({
                        roomGroupId, docId, docPageId, thumbnail,
                        key, obs,
                        resolve, reject,
                    });
                    if(this.#roomDocDownloadUrlJob.length > 1){
                        return;
                    }
                    let runJob = async (time) => {
                        if(this.#roomDocDownloadUrlJob.length === 0) return;
                        setTimeout(async () => {
                            const job = this.#roomDocDownloadUrlJob.shift();
                            if(!job) return;
                            let {
                                roomGroupId, docId, docPageId, thumbnail,
                                key, obs
                            } = job;
                            // console.log('@@ download!! :', time, this.__st ? Date.now() - this.__st : '')
                            // this.__st = Date.now();
                            let res = await this.#roomDocService.createRoomDocDownloadUrl({roomGroupId, docId, docPageId, thumbnail})
                            url = res.data.url;
                            this.#pageCacheData[key] = url;
                            obs.complete(this.#pageCacheData[key]);

                            let lastTime = this.#roomDocDownloadUrlJob.lastTime || Date.now();
                            this.#roomDocDownloadUrlJob.lastTime = Date.now()
                            await runJob(Math.max(5-lastTime, 0));
                        }, time);
                    };
                    await runJob(0);
                    return;
                }
                this.#pageCacheData[key] = url;
                obs.complete(this.#pageCacheData[key]);
            }).subscribe(
                resolve,
                reject,
                () => {}
            );
        });
    }

    async removeRoomDoc({roomGroupId, docId}) {
        await this.#roomDocService.removeRoomDoc({roomGroupId, docId});
    }

    async changeRoomDocSharing(roomGroupId) {
        await this.#roomDocService.changeRoomDocSharing(roomGroupId);
    }

    async createImage({filename, file, width, height, imageType, quality, ignoreMinSize}) {
        return new Promise((resolve, reject) => {
            filename = filename || file.name;

            const img = document.createElement('img');
            img.src = URL.createObjectURL(file);
            img.onerror = reject;
            img.onload = function() {
                URL.revokeObjectURL(this.src);

                let w = width, h = height;
                let ratio = Math.min(w / this.width, h / this.height, 1);
                if (this.width < w && this.height < h) {
                    w = this.width, h = this.height;
                    ratio = 1;
                }

                if(ratio >= 1 && ignoreMinSize === true){
                    resolve(file);
                    return;
                }

                w = this.width * ratio;
                h = this.height * ratio;

                const cvs = document.createElement('canvas');
                cvs.width = w;
                cvs.height = h;
                const ctx = cvs.getContext('2d');
                ctx.drawImage(this, 0, 0, w, h);
                try {
                    URL.revokeObjectURL(this.src);
                } catch (e) {
                    console.warn(e);
                }

                switch(imageType){
                    case 'png':
                        imageType = 'image/png';
                        break;
                    case 'jpg':
                        imageType = 'image/jpeg';
                        break;
                    default: {
                        let f_ext = filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
                        if (f_ext === 'png') {
                            imageType = 'image/png';
                        }
                        break;
                    }
                }

                cvs.toBlob(function (blob) {
                    blob.name = filename;
                    resolve(blob);
                }, imageType || 'image/jpeg', quality || 0.9);
            }
        });
    }
}

export const RoomDoc = new RoomDocApi();